import { Pie } from "react-chartjs-2";
import { Chart as ChartJS } from "chart.js/auto";

export const PieChart = ({data, config}) => {
  return (
    <Pie data={data} {...config} />
  )
}